<template>
	<div class="stage stage--intro" :style="{ 'background-image': backgroundImage }" :class="'block'+currentBlock">

		<div class="stage--intro__background-overlay background-overlay">

			<div class="content-container">

				<div class="header__container header__container-intro">

					<div class="animated-header" style="position: relative" v-if="isAnimation">
						<div class="animated-header-part1">{{textAnimationParts[0]}}</div>
						<div :class="isShown" class="animated-header-part2">{{textAnimationParts[1]}}</div>
						<div class="animated-header-part3">{{textAnimationParts[2]}}</div>
					</div>
					<div class="header" style="position: relative" v-html="stageData.header" v-else>
					</div>
					
					<div class="subHeader" style="position: relative; text-align: center;" v-html="stageData.subheader">
					</div>

					<div class="text" style="position: relative" v-html="stageData.story">
					</div>
				</div>

				<div class="visual-container">
					<Lottie
							:animationpath="baseUrl + stageData.visual"
							:audiopath="false"
							name="intro-animation"
							loop="true"
							ratio="slice"
							autoplay="true"
							style="margin:auto; position: absolute"
							v-if="visualExists && visualIsJson"
					/>

					<div class="centered centered-fluid" v-else-if="visualExists" :style="opacity_style_base">
						<img
								:src="baseUrl + stageData.visual"
								class="visual"
						/>
					</div>

					<Lottie
							:animationpath="baseUrl + stageData.visual_overlay"
							:audiopath="false"
							name="intro-animation-overlay"
							loop="true"
							ratio="slice"
							autoplay="true"
							style="margin:auto; position: absolute"
							:opacity="opacity"
							v-if="visualExists && visualIsJson && visualOverlayExists"
					/>

					<div class="centered centered-fluid overlay" v-else-if="visualExists && visualOverlayExists" :style="opacity_style">
						<img
								:src="baseUrl + stageData.visual_overlay"
								class="visual"
						/>
					</div>
				</div>


				<div class="slider-holder" v-if="isAnimation">
					0&nbsp;
					<div class="slider-interface">
						<div class="slider"></div>
					</div>
					&nbsp;100
					<div class="slider-hint" :class="understood">Sleep!</div>
				</div>


				<div class="popup email-verification" v-if="showVerifyEmail && !emailVerificationCompleted" :style="{ 'background-image': verficiationBackgroundImage }"> 	  
					<div class="form-section" v-if="!tokenRequested">

						<div class="header__container header__container-verification">
							<div class="header" style="position: relative" v-html="globalSettings.verification.header">
							</div>
							
							<div class="subHeader" style="position: relative; text-align: center;" v-html="globalSettings.verification.subheader">
							</div>
						</div>

						<div class="text" style="position: relative">
							<p v-html="globalSettings.verification.text"></p>
							<div class="input_container">
								<div class="input_icon">
									<img src="http://stereointellect.org/media/instances/32/envelop.svg" alt="">
								</div>
								<input class="textfield" type="text" v-model="email" placeholder="E-mail">
							</div>
							
							<p class="feedback">{{verification_feedback}}</p>
						</div>

					</div>

					<div class="form-section" v-if="tokenRequested">

						<div class="header__container header__container-verification">
							<div class="header" style="position: relative" v-html="globalSettings.verification.header">
							</div>
							
							<div class="subHeader" style="position: relative; text-align: center;" v-html="globalSettings.verification.subheader">
							</div>
						</div>

						<div class="text" style="position: relative">
							<p v-html="globalSettings.verification.token_text"></p>
							<div class="input_container">
								<div class="input_icon">
									<img src="http://stereointellect.org/media/instances/32/key.svg" alt="">
								</div>
								<input class="textfield" type="text" v-model="usertoken" placeholder="Token">
							</div>
							<p class="feedback">{{token_feedback}}</p>
						</div>

					</div>
				</div>

			</div>

		</div>

	</div>
</template>

<script>

	import Vue from 'vue';
	import { mapGetters , mapActions } from 'vuex';
	import { url} from '../../const/base';
	import { api_url} from '../../const/base';
	import Lottie from '../Lottie.vue';

	export default {

		components:{
			Lottie,
		},

		data(){
			return{
				apiUrl : api_url,
				headerReady: true,
				visualReady: true,
				storyReady: true,
				opacity_style_base: 'opacity: 1',
				opacity: 0,
				opacity_style: 'opacity: 0',
				isShown: 'hide', 
				audiopath: 'media/instance_2/Nordwin_transitor.mp3',
				name: 'introaudio',
				understood: 'no',
				is_animation: false,
				textAnimationParts: [],
				verifyEmail: 'Off',
				showVerifyEmail: false,
				tokenRequested: false,
				email: '',
				usertoken: '',
				hash: false,
				verification_feedback: '',
				token_feedback: '',
			}
		},

		beforeDestroy(){
			Vue.unloadAudio(this.name);
		},

		beforeMount(){

			this.textAnimation();

			if(typeof this.globalSettings.verification.mode !== 'undefined'){
				this.verifyEmail = this.globalSettings.verification.mode;
				if(this.verifyEmail === 'On'){
					console.log('verification?');
					console.log(this.globalSettings.verification.mode);
					this.showVerifyEmail = true;
				}
			}

		},

		mounted(){



			this.initAudio();

			var self = this;
			$('.slider').slider({
				slide: function(event, ui) {

					console.log(self.understood);
					if(self.understood=='no'){
						self.understood = 'hide';
					}

					self.opacity = ui.value/100;

					self.opacity_style = 'opacity: '+self.opacity;
					self.opacity_style_base = 'opacity: '+(1-self.opacity);

					if(ui.value > 99){
						console.log(ui.value);
						self.play();
						self.isShown = 'show';
						self.showNextButton();
					}else{
						self.isShown = 'hide';
					}

				}
			});


			this.showTransitorScore(false);

			if(this.lastStage){

				console.log('last stage');

				if(this.verifyEmail === 'On' && this.emailVerificationCompleted !== true){
					console.log('set verification action');
					this.setNextButtonAction(this.requestToken).then(()=>{
						this.showNextButton();
					});

				}else if(this.isAnimation){

					this.setNextButtonAction(this.stopBlockTransition);
					
				}else{

					this.setNextButtonAction(this.stopBlockTransition).then(()=>{
						this.showNextButton();
					});

				}


			}
			else if(this.verifyEmail === 'On' && this.emailVerificationCompleted !== true){
				console.log('set verification action');
				this.setNextButtonAction(this.requestToken).then(()=>{
					this.showNextButton();
				});
			}
			else{
				this.setNextButtonAction(this.toNextStage).then(()=>{
					this.showNextButton();
				});
			}
		},

		methods:{
			...mapActions([
				"hideNextButton",
				"showNextButton",
				"setNextButtonAction",
				"toNextStage",
				"stopBlockTransition",
				"showTransitorScore",
				"loadAudio",
				"setEmailVerificationCompleted",
			]),

			requestToken(){

				this.hideNextButton();

				
				let sendObj = {
					"instance_id" : this.instanceId,
					"email" : this.email
				};

				//console.log("sendObj");
				//console.log(sendObj);

				this.verification_feedback = '';

				Vue.http.post(this.apiUrl + 'api/v2/requesttoken' , sendObj).then(response => {
					console.log(response.status);
					console.log(response.statusText);
					console.log(response.body);

					if(response.body.result === 'success'){

						this.tokenRequested = true;
						this.hash = response.body.hash;

						console.log(this.hash);

						setTimeout(()=>{
							this.setNextButtonAction(this.verifyToken).then(()=>{
								this.showNextButton();
							});
						},500);
					}else{

						//console.log('invalid email!');

						//globalSettings.verification.text
						this.verification_feedback = this.globalSettings.verification.forbidden_text;

						this.setNextButtonAction(this.requestToken).then(()=>{
							this.showNextButton();
						});
					}

				}).catch(response => {
					//console.log("Error: ");
					//console.log(response);
				});

						
			},	

			verifyToken(){

				this.hideNextButton();

				let sendObj = {
					"instance_id" : this.instanceId,
					"hash" : this.hash,
					"user_token" : this.usertoken
				};

				this.token_feedback = '';

				Vue.http.post(this.apiUrl + 'api/v2/checktoken' , sendObj).then(response => {
					console.log(response.status);
					console.log(response.statusText);
					console.log(response.body);

					if(response.body.result === 'success'){

						this.verifyEmail = "Completed";
						this.showVerifyEmail = false;

						this.setEmailVerificationCompleted();
						
						setTimeout(()=>{
							if(this.visualOverlayExists){

								this.setNextButtonAction(this.stopBlockTransition);
								
							}else{

								this.setNextButtonAction(this.stopBlockTransition).then(()=>{
									this.showNextButton();
								});

							}
						},500);

					}else{

						console.log('invalid token!');

						//invalid_text
						this.token_feedback = this.globalSettings.verification.invalid_text;

						this.setNextButtonAction(this.verifyToken).then(()=>{
								this.showNextButton();
							});
					}

				}).catch(response => {
					//console.log("Error: ");
					//console.log(response);
				});




						
			},	

			play(){
				if(this.sound != null){
					console.log('playaudio');
					this.sound.play();
				}
			},

			initAudio(){

				Vue.loadAudio(this.name , this.baseUrl + this.audiopath, ()=>
				{
					this.sound = this.getAudio();
					//this.sound.play();
						
				}, ()=>{
					console.log("Failed to load audio: " + this.baseUrl + this.audiopath);
				});
			},

			playAudio(){
				return Vue.playAudio(this.name,  {loop:this.loop == "true"});
			},

			getAudio(){
				return Vue.getAudio(this.name, {loop:this.loop == "false"});
			},


		    textAnimation(){

		    	
		    	if(this.stageData.header !== null){

			    	const splitterPos = this.stageData.header.indexOf('[');

			    	if(splitterPos === false){

			    		return false;
			    	}

			    	const part1 = this.stageData.header.slice(0,splitterPos-1);

			    	const remainingString = this.stageData.header.slice(splitterPos+1);
			    	const splitterPos2 = remainingString.indexOf(']');

			    	const part2 = remainingString.slice(0,splitterPos2);
			    	const part3 = remainingString.slice(splitterPos2+2);


			    	this.textAnimationParts = [part1, part2, part3];
			    	console.log(this.textAnimationParts);

			    }

		    },
		},

		computed: {

			baseUrl(){
				return url;
			},

			...mapGetters([
				"stageData",
				"lastStage",
				"blocks",
				"scores",
				'currentBlock',
				"lastBlock",
				"globalSettings",
				"instanceId",
				"emailVerificationCompleted"
			]),

			visualExists(){
				return this.stageData != null && this.stageData.visual != null;
			},

			visualIsJson(){
				if(this.stageData == null || this.stageData.visual == null) return false;
				let fileExtension = this.stageData.visual.substr(this.stageData.visual.lastIndexOf('.') + 1);
				return fileExtension.toLowerCase() == 'json';
			},

			visualOverlayExists(){
				return this.stageData != null && this.stageData.visual_overlay != null;
			},

			isAnimation(){

				return this.stageData.is_animation === 'Yes';
			},

			backgroundImage: function() {
				
				if(typeof this.stageData.background === 'undefined'){ 
					return 'none'
				}

		        return 'url('+ this.baseUrl + this.stageData.background + ')';
		    },

			verficiationBackgroundImage: function() {
				
				if(typeof this.globalSettings.verification.background === 'undefined'){ 
					return 'none'
				}

		        return 'url('+ this.baseUrl + this.globalSettings.verification.background + ')';
		    },

		},
	}
</script>


// WEBPACK FOOTER //
// src/components/intro/Index.vue